export const ErrorPage = () => (
  <div className="text-white w-screen h-screen flex flex-col items-center justify-center">
    <img src="/assets/logo.svg" alt="logo" className="h-10" />
    <h2 className="text-xl font-bold mt-4 mb-2">An unhandled error occurred.</h2>
  </div>
);
